import { render, staticRenderFns } from "./ProgressStatistic.vue?vue&type=template&id=41b9baf4"
import script from "./ProgressStatistic.vue?vue&type=script&lang=js"
export * from "./ProgressStatistic.vue?vue&type=script&lang=js"
import style0 from "./ProgressStatistic.vue?vue&type=style&index=0&id=41b9baf4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports